<template>
  <div ref="root" class="relative mx-auto">
    <RevIllustration
      alt=""
      class="hidden md:block"
      :height="256"
      src="/img/product/jp/marketplace-large.png"
      :width="1184"
    />
    <RevIllustration
      alt=""
      class="block md:hidden"
      :height="181"
      src="/img/product/jp/marketplace-small.png"
      :width="375"
    />

    <div
      class="absolute left-0 right-0 top-1/2 flex max-w-[395px] -translate-y-1/2 flex-col gap-8 px-24 text-center md:left-1/2 md:right-auto md:-translate-x-1/2"
    >
      <p class="caption">
        {{ i18n(translations.countries) }}
      </p>
      <h2 class="heading-2">
        {{ i18n(translations.title) }}
      </h2>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'
import { useIntersectionObserver } from '@vueuse/core'

import translations from './ReassuranceMarketplace.translations'

const i18n = useI18n()
const { trackProductBlockImpression } = useTracking()
const root = ref<HTMLElement | null>()

const { stop } = useIntersectionObserver(root, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackProductBlockImpression({
      block_name: 'reassurance_flags_block',
    })
    stop()
  }
})

onUnmounted(() => {
  stop()
})
</script>
